import { render } from "./AdminManageGroomersComp.vue?vue&type=template&id=d40f669c&scoped=true"
import script from "./AdminManageGroomersComp.vue?vue&type=script&lang=js"
export * from "./AdminManageGroomersComp.vue?vue&type=script&lang=js"

import "./AdminManageGroomersComp.vue?vue&type=style&index=0&id=d40f669c&scoped=true&lang=css"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d40f669c"]])

export default __exports__